import moment from 'moment';
import { Job } from '../focusDataModels/Job';

export class LaborShift {
	pk: string; //:venueKey
	sk: string; //shift_{jobId}_{shiftKey}
	jobId: number;
	shiftKey: string;
	startTime: string;
	endTime: string;
	name: string;
	note: string;
	active: boolean = true;
	color: string;
	created: string = moment().format();
	modified: string = moment().format();
	deleted: boolean = false;

	jobName: string;

	job: Job;

	visible: boolean = false;

	public constructor(init?: Partial<LaborShift>) {
		Object.assign(this, init);
	}
}
